module.exports = __webpack_public_path__ + "img/base_divers_webcam.fbea7dcd.svg";